// This file contains the Avinor color constants
// They are defined as fixed variables, instead of getting them from the CSS/DOM (as it was previously done),
// to avoid issues on load, where the colors were not available in the CSS/DOM. It's also more performant.
export const AvinorColor = {
    VioletPrimary: "#b5208f",
    VioletPrimaryLight: "#d546b0",
    VioletPrimaryDark: "#960571",
    MintGreenPrimary: "#72d5d0",
    MintGreenPrimaryLight: "#91e3df",
    MintGreenPrimaryDark: "#f1fdfd",
    YellowWarningPrimary: "#ebbe05",
    YellowWarningPrimaryLight: "#fff9db",
    YellowWarningPrimaryDark: "#7a6300",
    RedAlarmPrimary: "#e02900",
    RedAlarmPrimaryLight: "#ffedeb",
    RedAlarmPrimaryDark: "#851800",
    BlueAttentionPrimary: "#097cbe",
    BlueAttentionPrimaryLight: "#ebf6ff",
    BlueAttentionPrimaryDark: "#004578",
    GreenSuccessPrimary: "#2a9d5a",
    GreenSuccessPrimaryLight: "#effbf4",
    GreenSuccessPrimaryDark: "#196538",
    ChartGrey900: "#161e28",
    ChartGrey200: "#b1bcc8",
    ChartVioletLight100: "#fab4e6",
    ChartVioletLight400: "#b5208f",
    ChartVioletLight600: "#6a004d",
    ChartVioletDark600: "#4c0039",
    ChartMintGreen400: "#42b8b2",
    ChartMintGreen300: "#72d5d0",
    ChartTangerine200: "#feba97",
    MintGreen50: "#f1fdfd",
    MintGreen100: "#bef3f1",
    MintGreen200: "#91e3df",
    MintGreen300: "#72d5d0",
    MintGreen400: "#42b8b2",
    MintGreen500: "#22958f",
    MintGreen600: "#0c6762",
    Green50: "#effbf4",
    Green100: "#a8e8c2",
    Green200: "#65d493",
    Green300: "#36c571",
    Green400: "#2a9d5a",
    Green500: "#21834a",
    Green600: "#196538",
    VioletDark50: "#fcf3f9",
    VioletDark100: "#e6b4d9",
    VioletDark200: "#cb7cb7",
    VioletDark300: "#aa4c93",
    VioletDark400: "#84216b",
    VioletDark500: "#6c0c54",
    VioletDark600: "#4c0039",
    VioletLight50: "#fff0fb",
    VioletLight100: "#fab4e6",
    VioletLight200: "#ec78cd",
    VioletLight300: "#d546b0",
    VioletLight400: "#b5208f",
    VioletLight500: "#960571",
    VioletLight600: "#6a004d",
    Yellow50: "#fff9db",
    Yellow100: "#ffeb99",
    Yellow200: "#fedf66",
    Yellow300: "#f9d233",
    Yellow400: "#ebbe05",
    Yellow500: "#a88700",
    Yellow600: "#7a6300",
    Blue50: "#ebf6ff",
    Blue100: "#acdafc",
    Blue200: "#73beef",
    Blue300: "#399edb",
    Blue400: "#097cbe",
    Blue500: "#0062a1",
    Blue600: "#004578",
    Red50: "#ffedeb",
    Red100: "#fdbeb3",
    Red200: "#fc725a",
    Red300: "#fb4b24",
    Red400: "#e02900",
    Red500: "#b12000",
    Red600: "#851800",
    Tangerine50: "#ffece1",
    Tangerine100: "#ffd2bb",
    Tangerine200: "#feba97",
    Tangerine300: "#faa275",
    Tangerine400: "#b77756",
    Tangerine500: "#754c37",
    Tangerine600: "#322017",
    Grey50: "#f6f7f9",
    Grey100: "#d7dee4",
    Grey200: "#b1bcc8",
    Grey300: "#8393a5",
    Grey400: "#6b7e94",
    Grey500: "#5c6c7f",
    Grey600: "#3b4959",
    Grey700: "#2a3541",
    Grey800: "#1c2530",
    Grey900: "#161e28",
    White: "#fff",
    HeaderTextSubtle: "#9ca1a9",
};
